import moment from 'moment';
import { div, truncate, mul } from './Decimal';
import { isObject } from 'lodash';
import { defaultSearchStatus } from '@/Libs/Orders';
/*
export const reactElemFetchSearch = (value, url, callback) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function fake() {
    const str = querystring.encode({
      code: 'utf-8',
      q: value,
    });
    fetch(`${url}?${str}`)
      .then(response => response.json())
      .then((d) => {
        if (currentValue === value) {
          const result = d.data.data;
          const data = [];
          result.forEach((r) => {
            data.push({
              value: r.s_id,
              text: r.company,
            });
          });
          callback(data);
        }
      });
  }

  timeout = setTimeout(fake, 300);
}
*/

/**
 * 千分位 格式化 人民币金额, 含货币前缀¥
 */
export const CNYFormatter = (number) => {
  if (isNaN(Number(number))) {
    return 0;
  }
  return new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency: 'CNY',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  }).format(number);
};

/**
 * 千分位 格式化数字
 */
export const numberFormatter = (number) => {
  return new Intl.NumberFormat().format(number);
};

/**
 * 人民币:元 转换为 万元
 * 小数位: 截断
 */
export const CNYConvertK = (number, decimals = 2, scale = 10) => {
  return truncate(div(number, mul(1000, scale)), decimals);
};

/**
 * 数字转换中文大写金额
 */
export const numberConvertChinese = (n) => {
  if (n === 0) return '零';
  if (!/^\-?(0|[1-9]\d*)(\.\d+)?$/.test(n)) return '';
  var unit = '仟佰拾亿仟佰拾万仟佰拾元角分',
    str = '';
  n += '00';
  var p = n.indexOf('.');
  if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
  // unit = unit.substr(unit.length - n.length);
  unit = unit.substring(unit.length - n.length);
  for (var i = 0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
  return str
    .replace(/零(仟|佰|拾|角)/g, '零')
    .replace(/(零)+/g, '零')
    .replace(/零(万|亿|元)/g, '$1')
    .replace(/(亿)万/g, '$1$2')
    .replace(/^元零?|零分/g, '')
    .replace(/元$/g, '元整');
};

const currentPageHashStr = () => window.location.hash.replace(/^#\/?|\/?$/g, '').replace('/', '-');
export const saveSearchCondition = (str = '', key = '') => {
  key = !key ? currentPageHashStr() : key;
  sessionStorage.setItem(key, str);
};

export const clearSearchCondition = (key = '') => {
  key = !key ? currentPageHashStr() : key;
  sessionStorage.removeItem(key);
};

export const readSearchCondition = (key = '') => {
  key = !key ? currentPageHashStr() : key;
  return sessionStorage.getItem(key) || '';
};

export const readSearchObject = (key = '', parse = true) => {
  const q = readSearchCondition(key);
  const o = Object.fromEntries(new URLSearchParams(q));
  if (parse !== true) {
    return o;
  }
  Object.keys(o).map((key) => {
    if ((key.indexOf('_date') !== -1 || key.indexOf('time') !== -1) && o[key].split(',').length > 0) {
      o[key] = o[key]
        .split(',')
        .filter((s) => s)
        .map((d) => moment(d));
    }
    if ((key.indexOf('status') !== -1) && o[key].split(',').length > 0) {
      o[key] = o[key].split(',').map(ele => ({ key: ele, value: ele, label: ele }));
    }
    if ((key.indexOf('_id') !== -1) && key.endsWith('_id') && !isNaN(Number(o[key]))) {
      o[key.slice(0, -3)] = { key: o[key], label: o[key] };
      o[key] = { key: o[key], label: o[key] };
    }
    if (o.hasOwnProperty(`${key}_id`) && isObject(o[key])) {
      delete o[key];
    }
  });
  // Object.keys(o).forEach((key) => (o[key] == null || o[key] == '' || o[key].length === 0) && delete o[key]);
  return o;
};

/**
 * 去除无效的值: undefined, null, '', []
 * * 只删除 null undefined: 用 lodash: _.omitBy(obj, _.isNil);
 */
export const omitEmpty = (_object) => {
  Object.keys(_object).forEach(
    (key) => (_object[key] == null || _object[key] == '' || _object[key].length === 0) && delete _object[key]
  );
  return _object;
}
